import axios from "axios";
import { message } from "antd";
import i18next from "i18next";
import { history } from "../app";
import $authHost from "./auth";

const { t } = i18next;

const errorInterceptor = (error: any) => {
  if (error.response?.status === 401) {
    if (window.location.pathname.includes("signedIn")) {
      return Promise.reject(error);
    }

    if (error.request.responseURL.endsWith("refresh")) {
      history.push("/login");
      return Promise.reject(error);
    }

    let refreshToken = localStorage.getItem("refreshToken");
    if (!refreshToken) {
      history.push("/login");
      return Promise.reject(error);
    }

    return axios
      .post(`${process.env.REACT_APP_API_URL}/Identity/user/token/refresh`, { refreshToken })
      .then((res) => {
        localStorage.setItem("accessToken", res.data.accessToken);
        localStorage.setItem("refreshToken", res.data.refreshToken.refreshToken);

        return $authHost.request(error.config);
      })
      .catch((_) => {
        history.push("/login");
      });
  }
  if (error.response) {
    message.error(
      `${t("error")} ${error.response.status}: ${error.response?.data?.title || t("badRequestPleaseTryAgainLater")}`,
      7
    );
  }
  return Promise.reject(error);
};

axios.interceptors.response.use(undefined, errorInterceptor);

export { errorInterceptor };
